import {connect} from 'react-redux';
import ValidateDomainModal, {AVAILABLE_ACTIONS} from './ValidateDomainModal';
import {
    getActiveModal, hideModal,
    MODAL_VALIDATE_DOMAIN
} from '../../../../reducers/common/activeModal';
import {
    getContinentsData,
    getCountriesData,
    getCurrentContinent,
    setCurrentContinent, setCurrentContinentByCountry
} from '../../../../reducers/common/location';
import {getTranslation} from '../../../../reducers/common/localization';
import {getSubmitFormSuccessStatus} from '../../../../reducers/common/submitForm';
import {
    onValidateDomain
} from '../../../../reducers/accreditation/unreferencedAccreditationRequests';

const mapStateToProps = state => {
    return {
        action: AVAILABLE_ACTIONS.VALIDATE,
        isOpen: getActiveModal(state).modalKey === MODAL_VALIDATE_DOMAIN,
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        translation: getTranslation(state),
        success: getSubmitFormSuccessStatus(state)
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        onSubmit: (data, bavaManaged) => {
            dispatch(onValidateDomain(props.data.orgDomain, data, bavaManaged));
        },
        onCancel: () => {
            dispatch(hideModal());
            dispatch(setCurrentContinent(''));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateDomainModal);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/validateDomainModal/ValidateDomainModal.container.js